import { render, staticRenderFns } from "./shortLinkButtons.vue?vue&type=template&id=06781bd6"
import script from "./shortLinkButtons.vue?vue&type=script&lang=js"
export * from "./shortLinkButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports